import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { UserRole } from '../../models/enums/user-role.enum';

@Pipe({
  name: 'userRole',
  standalone: true,
  pure: false,
})
export class UserRolePipe implements PipeTransform {
  private readonly _transloco = inject(TranslocoService);

  transform(value: UserRole): string {
    switch (value) {
      case UserRole.OWNER:
        return this._transloco.translate('enums.userRole.owner');
      case UserRole.ADMIN:
        return this._transloco.translate('enums.userRole.admin');
      default:
        return this._transloco.translate('enums.userRole.member');
    }
  }
}
